import './SplashScreen.css';
import { useEffect, useState, useRef } from 'react';
import { gsap } from 'gsap';
import logo from '../../logo.png';

function SplashScreen({ onComplete }) {
  const [isVisible, setIsVisible] = useState(true);
  const logoRef = useRef(null);

  useEffect(() => {
    // Kontrollo nëse duhet të shfaqet splash screen (për testim)
    const forceShow = new URLSearchParams(window.location.search).get('splash') === 'true';
    
    // Kontrollo nëse është vizituar më parë
    const hasVisited = localStorage.getItem('hasVisitedShalaAccounting');
    
    if (hasVisited && !forceShow) {
      // Nëse është vizituar më parë dhe nuk forcohet, shfaq faqen direkt
      onComplete();
      return;
    }

    // Vendos gjendjen fillestare
    gsap.set(logoRef.current, {
      opacity: 0,
      scale: 0.5,
      rotation: -10
    });

    // Krijo timeline për animacionin
    const tl = gsap.timeline({
      onComplete: () => {
        // Ruaj që është vizituar (vetëm nëse nuk forcohet)
        if (!forceShow) {
          localStorage.setItem('hasVisitedShalaAccounting', 'true');
        }
        
        // Prit pak dhe pastaj fshi splash screen
        setTimeout(() => {
          setIsVisible(false);
          setTimeout(() => {
            onComplete();
          }, 500);
        }, 1000);
      }
    });

    // Animo logon
    tl.to(logoRef.current, {
      opacity: 1,
      scale: 1,
      rotation: 0,
      duration: 1.2,
      ease: "back.out(1.7)"
    })
    .to(logoRef.current, {
      scale: 1.1,
      duration: 0.3,
      ease: "power2.out"
    })
    .to(logoRef.current, {
      scale: 1,
      duration: 0.3,
      ease: "power2.out"
    });

  }, [onComplete]);

  if (!isVisible) {
    return null;
  }

  return (
    <div className="splash-screen">
      <div className="splash-content">
        <img 
          ref={logoRef}
          src={logo} 
          alt="ShalaAccounting Logo" 
          className="splash-logo"
        />
        <div className="splash-text">
          ShalaAccounting
        </div>
      </div>
    </div>
  );
}

export default SplashScreen; 